import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class Accordion extends React.Component {
  static propTypes = {
    expanded: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.any,
    header: PropTypes.any,
    headerProperties: PropTypes.any,
    id: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      expanded: props.expanded,
    };
  }

  toggle = () => {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { children, className, header, headerProperties, id} = this.props;
    const classes = [
      'ea-accordion__element',
      {'ea-accordion__element--expanded': this.state.expanded}];

    return (
      <div id={ id }
           className={ classnames(className, classes) } onClick={ () => this.toggle()}>
        <div className="ea-accordion__header" {...headerProperties}>
          {header}
        </div>
        <div className="ea-accordion__content">
          {children}
        </div>
      </div>
    );
  }

}

export default Accordion;



// WEBPACK FOOTER //
// ./web/js/components/react-patterns/accordion/Accordion.js